<template>
  <div class="p-8 my-3 bg-primary-300 stack rounded" v-if="survey">
    <div class="mx-auto text-5xl mb-3">
      <icon name="WaldigLogo" :settings="{circle: true, strokeWidth: 1}" />
    </div>
    <p class="text-lg">{{survey.question}}</p>
    <div v-if="options.length > 0">
      <survey-option-preview v-for="option in options" :key="option.id" :option="option" />
    </div>
    <div class="text-right">
      <wd-button black>Abschicken</wd-button>
    </div>
  </div>
</template>

<script>
import { Survey } from "@/modules/surveys/viewmodels/Survey";
import DateMixin from "@/mixins/DateMixin";

const SurveyOptionPreview = require("@/modules/surveys/components/SurveyOptionPreview.vue")
  .default;

export default {
  name: "SurveyPreview",
  mixins: [DateMixin],
  data() {
    return {
      survey: null
    };
  },
  props: {
    surveyId: {
      type: String,
      required: true
    },
    select: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SurveyOptionPreview
  },
  methods: {
    openManage() {
      this.goTo("/survey-manage/" + this.survey.id);
    },
    emitSelection() {
      this.$emit("selection");
    }
  },
  computed: {
    options() {
      return this.$store.getters["surveyoption/surveyOptionsOfSurvey"](
        this.surveyId
      );
    }
  },
  async created() {
    this.survey = await this.$store.getters["survey/api"].Show(this.surveyId);
    await this.$store.getters["surveyoption/api"].Custom.ShowOptionsOfSurvey(
      this.surveyId
    );
  }
};
</script>